import {TakeAwayProps} from '@/interfaces/models/takeAway';

export default class TakeAway {
  id: string;
  isCooking: boolean;
  isDone: boolean;
  orderNumberInQueue: string;
  systemOrderNumber: number;

  constructor(
    id: string,
    isCooking: boolean,
    isDone: boolean,
    orderNumberInQueue: string,
    systemOrderNumber: number,
  ) {
    this.id = id;
    this.isCooking = isCooking;
    this.isDone = isDone;
    this.orderNumberInQueue = orderNumberInQueue;
    this.systemOrderNumber = systemOrderNumber;
  }

  public static createFromRequest(takeAwayProps: TakeAwayProps): TakeAway {
    return new TakeAway(
      takeAwayProps.id,
      takeAwayProps.isCooking,
      takeAwayProps.isDone,
      takeAwayProps.orderNumberInQueue,
      takeAwayProps.systemOrderNumber,
    );
  }

  public done() {
    this.isDone = true;
    this.isCooking = false;
  }

  public undone() {
    this.isDone = false;
    this.isCooking = true;
  }
}
